import {
	PopoverContent,
	PopoverProvider,
	PopoverTarget,
	SpotlightActions,
	SpotlightBody,
	SpotlightCard,
	SpotlightControls,
	SpotlightDismissControl,
	SpotlightFooter,
	SpotlightHeader,
	SpotlightHeadline,
	SpotlightMedia,
	SpotlightPrimaryAction,
} from '@atlaskit/spotlight';
import Image from '@atlaskit/image';
import { Text } from '@atlaskit/primitives/compiled';
import { FormattedMessage, useIntl } from 'react-intl';

import { type marketplaceOpsMessages } from './messages';
import spotlightMediaImage from './assets/spotlight-media.svg';
import { type JSX } from 'react/jsx-runtime';

export interface OperationsMenuItemSpotlightProps {
	dismiss: () => void;
	onPrimaryAction: () => void;
	messages: typeof marketplaceOpsMessages;
}

export const OperationsMenuItemSpotlight = ({
	dismiss,
	onPrimaryAction,
	messages,
}: OperationsMenuItemSpotlightProps): JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<PopoverProvider>
			<PopoverTarget>
				<div />
			</PopoverTarget>
			<PopoverContent dismiss={dismiss} placement="right-end" isVisible={true}>
				<SpotlightCard>
					<SpotlightHeader>
						<SpotlightHeadline>
							<FormattedMessage {...messages.heading} />
						</SpotlightHeadline>
						<SpotlightControls>
							<SpotlightDismissControl autoFocus={false} />
						</SpotlightControls>
					</SpotlightHeader>
					<SpotlightMedia>
						<Image src={spotlightMediaImage} alt={formatMessage(messages.heading)} />
					</SpotlightMedia>
					<SpotlightBody>
						<Text>
							<FormattedMessage {...messages.description} />
						</Text>
					</SpotlightBody>
					<SpotlightFooter>
						<SpotlightActions>
							<SpotlightPrimaryAction onClick={onPrimaryAction}>
								<FormattedMessage {...messages.primaryAction} />
							</SpotlightPrimaryAction>
						</SpotlightActions>
					</SpotlightFooter>
				</SpotlightCard>
			</PopoverContent>
		</PopoverProvider>
	);
};
